import { render, staticRenderFns } from "./RelationItem.vue?vue&type=template&id=67e6fa85&scoped=true"
import script from "./RelationItem.vue?vue&type=script&lang=js"
export * from "./RelationItem.vue?vue&type=script&lang=js"
import style0 from "./RelationItem.vue?vue&type=style&index=0&id=67e6fa85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e6fa85",
  null
  
)

export default component.exports